<template>
  <section class="layout-pt-lg layout-pb-lg"  :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`">
    <div class="tw-w-full">
     
      
      

    
      <div class="tw-space-y-10">
        <div
          v-for="(branch, index) in branches"
          :key="`contact-us-branch-${index}`"
          class="tw-grid tw-grid-cols-1 tw-items-center tw-overflow-hidden xl:tw-grid-cols-2"
          
        >
        
       
          <div class="tw-p-6">
            <LibraryImage
              :src="branch.photo"
              :w-ratio="720"
              :h-ratio="405"
              
            />
          </div>

          
           
          <div class="tw-p-6 md:tw-p-6 lg:tw-p-10">
            <div >
          <div v-if="vars.titleHtml" class="tw-mb-8" v-html="vars.titleHtml"></div>
          </div>
          <h3 v-if="branch.title" class="tw-mb-4">{{ branch.title }} </h3>

            <div class="tw-grid tw-grid-cols-1 tw-gap-5 lg:tw-grid-cols-2">
            
              <div class="tw-col-span-1 tw-space-y-8">
              
                 
                <div class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  
                  <div class="tw-w-full tw-space-y-2">
                    <small>ADDRESS</small>
                    <p :style="`color: var(--c-${vars.textColor}) !important;`">
  {{ branch.address }}
</p>


                  </div>
                </div>

                <div v-if="branch.primary_phone" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-w-full tw-space-y-2">
                    <small>PHONE</small>
                    <p :style="`color: var(--c-${vars.textColor}) !important;`">
                      <nuxt-link :to="`tel:${branch.primary_phone}`" class="n-link" :external="true">
                        {{ branch.primary_phone }}
                      </nuxt-link>
                    </p>
                    
                  </div>
                </div>

                <!-- E-Posta -->
                <div v-if="branch.primary_email" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-line-clamp-2 tw-space-y-2">
                    <small>EMAIL</small>
                    <p :style="`color: var(--c-${vars.textColor}) !important;`" :title="branch.primary_email" class="scrollbar tw-overflow-x-auto">
                      <nuxt-link v-if="branch.primary_email" :to="`mailto:${branch.primary_email}`" class="n-link" :external="true">
                        {{ branch.primary_email }}
                      </nuxt-link>
                    </p>
                    
                  </div>
                </div>

                <div v-if="branch.facebook_url || branch.instagram_url || branch.linkedin_url || branch.youtube_url || branch.tiktok_url" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-w-full tw-space-y-2">
                    <small>SOCIALS</small>
                    <div class="tw-flex tw-gap-3">
                      <!-- Facebook -->
                      <a v-if="branch.facebook_url" :href="branch.facebook_url || '#'" class="n-link tw-group" target="_blank">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#1B3B47"/>
<path d="M19.3346 19H21.0013L21.668 16.3334H19.3346V15C19.3346 14.3134 19.3346 13.6667 20.668 13.6667H21.668V11.4267C21.4506 11.398 20.63 11.3334 19.7633 11.3334C17.9533 11.3334 16.668 12.438 16.668 14.4667V16.3334H14.668V19H16.668V24.6667H19.3346V19Z" fill="white"/>
</svg>

                      </a>

                      <!-- Instagram -->
                      <a v-if="branch.instagram_url" :href="branch.instagram_url || '#'" class="n-link tw-group" target="_blank">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#1B3B47"/>
<path d="M15.1987 11.3334H20.7987C22.932 11.3334 24.6654 13.0667 24.6654 15.2V20.8C24.6654 21.8255 24.258 22.809 23.5328 23.5342C22.8077 24.2593 21.8242 24.6667 20.7987 24.6667H15.1987C13.0654 24.6667 11.332 22.9334 11.332 20.8V15.2C11.332 14.1745 11.7394 13.191 12.4646 12.4659C13.1897 11.7408 14.1732 11.3334 15.1987 11.3334ZM15.0654 12.6667C14.4288 12.6667 13.8184 12.9196 13.3683 13.3697C12.9182 13.8197 12.6654 14.4302 12.6654 15.0667V20.9334C12.6654 22.26 13.7387 23.3334 15.0654 23.3334H20.932C21.5686 23.3334 22.179 23.0805 22.6291 22.6304C23.0792 22.1803 23.332 21.5699 23.332 20.9334V15.0667C23.332 13.74 22.2587 12.6667 20.932 12.6667H15.0654ZM21.4987 13.6667C21.7197 13.6667 21.9317 13.7545 22.088 13.9108C22.2442 14.0671 22.332 14.279 22.332 14.5C22.332 14.7211 22.2442 14.933 22.088 15.0893C21.9317 15.2456 21.7197 15.3334 21.4987 15.3334C21.2777 15.3334 21.0657 15.2456 20.9094 15.0893C20.7532 14.933 20.6654 14.7211 20.6654 14.5C20.6654 14.279 20.7532 14.0671 20.9094 13.9108C21.0657 13.7545 21.2777 13.6667 21.4987 13.6667ZM17.9987 14.6667C18.8828 14.6667 19.7306 15.0179 20.3557 15.643C20.9808 16.2681 21.332 17.116 21.332 18C21.332 18.8841 20.9808 19.7319 20.3557 20.3571C19.7306 20.9822 18.8828 21.3334 17.9987 21.3334C17.1146 21.3334 16.2668 20.9822 15.6417 20.3571C15.0166 19.7319 14.6654 18.8841 14.6654 18C14.6654 17.116 15.0166 16.2681 15.6417 15.643C16.2668 15.0179 17.1146 14.6667 17.9987 14.6667ZM17.9987 16C17.4683 16 16.9596 16.2108 16.5845 16.5858C16.2094 16.9609 15.9987 17.4696 15.9987 18C15.9987 18.5305 16.2094 19.0392 16.5845 19.4143C16.9596 19.7893 17.4683 20 17.9987 20C18.5291 20 19.0378 19.7893 19.4129 19.4143C19.788 19.0392 19.9987 18.5305 19.9987 18C19.9987 17.4696 19.788 16.9609 19.4129 16.5858C19.0378 16.2108 18.5291 16 17.9987 16Z" fill="white"/>
</svg>

                      </a>

                      <!-- LinkedIn -->
                      <a v-if="branch.linkedin_url" :href="branch.linkedin_url || '#'" class="n-link tw-group" target="_blank">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#1B3B47"/>
<path d="M14.6276 13.3334C14.6274 13.687 14.4868 14.0261 14.2366 14.276C13.9864 14.5259 13.6472 14.6662 13.2936 14.6661C12.94 14.6659 12.6009 14.5252 12.351 14.2751C12.1011 14.0249 11.9608 13.6857 11.9609 13.3321C11.9611 12.9784 12.1018 12.6394 12.3519 12.3894C12.6021 12.1395 12.9413 11.9992 13.2949 11.9994C13.6486 11.9996 13.9876 12.1402 14.2376 12.3904C14.4875 12.6406 14.6278 12.9798 14.6276 13.3334ZM14.6676 15.6534H12.0009V24.0001H14.6676V15.6534ZM18.8809 15.6534H16.2276V24.0001H18.8543V19.6201C18.8543 17.1801 22.0343 16.9534 22.0343 19.6201V24.0001H24.6676V18.7134C24.6676 14.6001 19.9609 14.7534 18.8543 16.7734L18.8809 15.6534Z" fill="white"/>
</svg>

                      </a>
                      <a v-if="branch.youtube_url" :href="branch.youtube_url || '#'" class="n-link tw-group" target="_blank">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#1B3B47"/>
<g clip-path="url(#clip0_79_2241)">
<path d="M17.9987 12.6666C18.5687 12.6666 19.1534 12.6813 19.72 12.7053L20.3894 12.7373L21.03 12.7753L21.63 12.816L22.178 12.8586C22.7727 12.9041 23.3323 13.1579 23.7584 13.5753C24.1844 13.9927 24.4496 14.547 24.5074 15.1406L24.534 15.424L24.584 16.0306C24.6307 16.6593 24.6654 17.3446 24.6654 18C24.6654 18.6553 24.6307 19.3406 24.584 19.9693L24.534 20.576C24.5254 20.6733 24.5167 20.7673 24.5074 20.8593C24.4496 21.453 24.1843 22.0074 23.7581 22.4248C23.3319 22.8422 22.7722 23.0959 22.1774 23.1413L21.6307 23.1833L21.0307 23.2246L20.3894 23.2626L19.72 23.2946C19.1466 23.3195 18.5727 23.3324 17.9987 23.3333C17.4247 23.3324 16.8508 23.3195 16.2774 23.2946L15.608 23.2626L14.9674 23.2246L14.3674 23.1833L13.8194 23.1413C13.2247 23.0958 12.6651 22.842 12.239 22.4246C11.813 22.0072 11.5477 21.4529 11.49 20.8593L11.4634 20.576L11.4134 19.9693C11.3624 19.3141 11.3353 18.6572 11.332 18C11.332 17.3446 11.3667 16.6593 11.4134 16.0306L11.4634 15.424C11.472 15.3266 11.4807 15.2326 11.49 15.1406C11.5477 14.5471 11.8128 13.9929 12.2388 13.5755C12.6647 13.1581 13.2241 12.9043 13.8187 12.8586L14.366 12.816L14.966 12.7753L15.6074 12.7373L16.2767 12.7053C16.8504 12.6804 17.4245 12.6675 17.9987 12.6666ZM17.9987 14C17.4487 14 16.8827 14.0146 16.332 14.0373L15.68 14.0686L15.054 14.1053L14.466 14.1453L13.9274 14.1873C13.6443 14.2074 13.3774 14.3271 13.1741 14.5251C12.9708 14.7232 12.8442 14.9868 12.8167 15.2693C12.7387 16.0753 12.6654 17.0786 12.6654 18C12.6654 18.9213 12.7387 19.9246 12.8167 20.7306C12.8734 21.312 13.3347 21.764 13.9274 21.8126L14.466 21.854L15.054 21.894L15.68 21.9313L16.332 21.9626C16.8827 21.9853 17.4487 22 17.9987 22C18.5487 22 19.1147 21.9853 19.6654 21.9626L20.3174 21.9313L20.9434 21.8946L21.5314 21.8546L22.07 21.8126C22.3531 21.7925 22.62 21.6729 22.8233 21.4748C23.0266 21.2768 23.1532 21.0131 23.1807 20.7306C23.2587 19.9246 23.332 18.9213 23.332 18C23.332 17.0786 23.2587 16.0753 23.1807 15.2693C23.1532 14.9868 23.0266 14.7232 22.8233 14.5251C22.62 14.3271 22.3531 14.2074 22.07 14.1873L21.5314 14.146L20.9434 14.106L20.3174 14.0686L19.6654 14.0373C19.1101 14.0134 18.5545 14.001 17.9987 14ZM16.6654 16.3833C16.6653 16.3181 16.6812 16.254 16.7116 16.1963C16.742 16.1387 16.786 16.0894 16.8399 16.0526C16.8937 16.0159 16.9557 15.9929 17.0204 15.9856C17.0851 15.9782 17.1507 15.9868 17.2114 16.0106L17.2654 16.0373L20.0654 17.6533C20.1211 17.6855 20.1683 17.7306 20.2029 17.7849C20.2374 17.8392 20.2584 17.9011 20.264 17.9652C20.2695 18.0293 20.2595 18.0939 20.2348 18.1533C20.2101 18.2127 20.1714 18.2653 20.122 18.3066L20.0654 18.3466L17.2654 19.9633C17.2089 19.996 17.1454 20.0144 17.0802 20.0168C17.0151 20.0193 16.9503 20.0059 16.8915 19.9776C16.8328 19.9493 16.7818 19.9072 16.7431 19.8547C16.7044 19.8022 16.6791 19.7411 16.6694 19.6766L16.6654 19.6166V16.3833Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_79_2241">
<rect width="16" height="16" fill="white" transform="translate(10 10)"/>
</clipPath>
</defs>
</svg>

                      </a>

                      <!-- TikTok -->
                      <a v-if="branch.tiktok_url" :href="branch.tiktok_url || '#'" class="n-link tw-group" target="_blank">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#1B3B47"/>
<path d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z" fill="white"/>
</svg>

                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="tw-items-start">
                  <div class="tw-w-9"></div>
                  <div class="tw-w-full">
                    
                    <small>OPENING HOURS</small>
                    <div>
                     
                     

                     
                      <div  class="tw-mt-4 tw-space-y-4 tw-text-[#545454]">
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Monday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.monday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Tuesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.tuesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Wednesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.wednesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Thursday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.thursday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Friday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.friday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Saturday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.saturday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Sunday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.sunday }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          
            </div>
          </div>
         
        </div>
     
      </div>
    
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'ContactUs',
  mixins: [ComponentMixin],

  data() {
    return {
      form: null,
    };
  },

  computed: {
    branches() {
      return this.groupedVariables.branches;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

<style scoped>
.social_icons {
  border-radius: 100% !important;
  padding: 10px !important;
}

.scrollbar::-webkit-scrollbar {
  height: 3px;
  width: 6px;
}

.scrollbar::-webkit-scrollbar-track {
  background-color: #cbdceb;
  border-radius: 40px;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--c-primary);
  border-radius: 40px;
}

@media screen and (min-width: 1024px) {
  .scrollbar::-webkit-scrollbar {
    height: 5px;
  }
}
</style>
